import { Component, Inject, Input, OnInit, Optional } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { finalize } from "rxjs/operators";
import { ToastService } from "src/app/core";
import { ConfigurationApi, DocumentTypes } from "src/app/core/api.gen";
import { DialogService } from "src/app/core/dialog.service";
import { LoaderService } from "src/app/core/loader.service";

@Component({
  selector: "eos-governance-newdoc-types-edit",
  templateUrl: "./governance-newdoc-types-edit.component.html",
  styleUrls: ["./governance-newdoc-types-edit.component.css"],
})
export class GovernanceNewdocTypesEditComponent implements OnInit {
  @Input() activity: DocumentTypes;
  @Input() isEdit: boolean = false;
  @Input() documentTypes: DocumentTypes[] = [];

  private originalValue: any;

  createForm = new UntypedFormGroup({
    id: new UntypedFormControl(0),
    documentTypeName: new UntypedFormControl(null, [Validators.required, Validators.maxLength(200)]),
    isActive: new UntypedFormControl(true),
  });

  constructor(
    public modal: NgbActiveModal,
    private loader: LoaderService,
    private toast: ToastService,
    private configApi: ConfigurationApi,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    if (this.isEdit && this.activity) {
      this.createForm.patchValue({
        id: this.activity.id,
        documentTypeName: this.activity.documentTypeName,
        isActive: this.activity.isActive,
      });
      this.originalValue = this.createForm.getRawValue();
    }
  }

  get hasChanges(): boolean {
    return JSON.stringify(this.createForm.getRawValue()) !== JSON.stringify(this.originalValue);
  }

  save() {
    if (this.createForm.invalid) return;

    if (this.isEdit) {
      this.dialogService.showConfirmationBox(
        "Update Document Type",
        "Are you sure you want to update this document type?",
        () => this.saveDocumentType()
      );
    } else {
      this.saveDocumentType();
    }
  }

  private saveDocumentType() {
    const payload = DocumentTypes.fromJS(this.createForm.getRawValue());
    this.loader.show();
    this.configApi
      .saveDocumentType(payload)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(
        () => {
          this.toast.success(
            this.isEdit ? "Successfully updated document type" : "Successfully created document type"
          );
          this.modal.close("success");
        },
        () => this.toast.error("Error occurred, please try again!")
      );
  }

  get isDuplicate(): boolean {
    const normalize = (s: string) => s?.trim().replace(/\s+/g, '').toLowerCase() ?? '';
    const entered = normalize(this.createForm.get('documentTypeName')?.value);
    if (!entered) return false;
    return this.documentTypes.some(d => {
      if (this.isEdit && this.activity && d.id === this.activity.id) return false;
      return normalize(d.documentTypeName) === entered;
    });
  }
}